import { Map } from 'immutable';

import * as t from '../actions/resourcesActionTypes.js';

const initialState = Map({
  posts: [],
  featuredBlog: [{ name: 'Featured blog' }],
  categories: [{ name: 'ALL TOPICS', id: 0 }],
  isLoading: true,
  totalPosts: 0,
  loadMoreState: true,
});

const reducer = function resourcesReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_POSTS:
      return state.set('posts', state.get('posts').concat(action.value));
    case t.SET_CATEGORIES:
      return state.set(
        'categories',
        state.get('categories').concat(action.value),
      );
    case t.SET_FEATURED_BLOG:
      return state.set('featuredBlog', action.value);
    case t.SET_LOAD_MORE:
      return state.set('loadMoreState', action.value);
    case t.SET_IS_LOADING:
      return state.set('isLoading', action.value);
    case t.SET_TOTAL_POSTS:
      return state.set('totalPosts', action.value);
    case t.RESET_POSTS:
      return state.set('posts', []);
    case t.RESET_CATEGORIES:
      return state.set('categories', [{ name: 'ALL TOPICS', id: 0 }]);
    default:
      return state;
  }
};

export default reducer;
